import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/kpis',
    name: 'Kpis',
    component: () => import('@/views/Kpis.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/companies',
    name: 'Companies',
    component: () => import('@/views/Companies.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('@/views/Users.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/Profile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guard
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth !== false)
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)
  const isAuthenticated = store.getters['auth/isAuthenticated']
  const isAdmin = store.getters['auth/isAdmin']

  if (requiresAuth) {
    if (!isAuthenticated) {
      // Check if token is valid
      const tokenValid = await store.dispatch('auth/checkAuth')
      if (!tokenValid) {
        next('/login')
        return
      }
    }

    if (requiresAdmin && !isAdmin) {
      // User doesn't have admin privileges
      next('/')
      return
    }
  }

  if (to.name === 'Login' && isAuthenticated) {
    next('/')
    return
  }

  next()
})

export default router